import { PieChart, pieArcLabelClasses } from "@mui/x-charts/PieChart";
import { Spin } from "antd";
import React, { useContext, useEffect, useState } from "react";
import { Card, Col, Form, Row } from "react-bootstrap";
import PsContext from "../../context";
import { _DASHBOARD_FEE_RECEIVED_AMOUNT } from "../../models/dashboard";
import { commaFormatted, getTodayDate, momentDate } from "../../utils";

const FeeCollectionChart = (props) => {
  const context = useContext(PsContext);

  const [loader, setLoader] = useState(false);
  const [dataList, setDataList] = useState([]);
  const [today, setToday] = useState(momentDate(new Date(), "YYYY-MM-DD"));

  useEffect(() => {
    let m = context.getStorageByDate("dahboard_fee_chart_count_by_method");
    if (m) setDataList(m);
  }, []);

  useEffect(() => {
    loadData();
  }, [today]);

  const loadData = () => {
    setLoader(true);
    _DASHBOARD_FEE_RECEIVED_AMOUNT({ date: today }).then((res) => {
      if (res.status == "1") {
        context.setStorage(
          "dahboard_fee_chart_count_by_method",
          res.data,
          getTodayDate()
        );
        setDataList(res.data);
      }
      setLoader(false);
    });
  };

  const getChartData = () => {
    let rv = [];
    dataList.map((item) =>
      rv.push({
        id: item.payment_method_id,
        value: parseFloat(item.total_fee_amount).toFixed(0),
        label: item.payment_method_name,
      })
    );

    return rv;
  };

  const sizing = {
    margin: { right: 5 },
    width: 150,
    height: 150,
    legend: { hidden: true },
  };

  const data = getChartData();

  return (
    <>
      <Card>
        <Card.Header className="card-header-bg fw-bold text-uppercase">
          Amount Received
        </Card.Header>
        <Card.Body className="p-2">
          <Spin spinning={loader && dataList.length < 1}>
            <Row>
              <Col>
                <Form.Control
                  type="date"
                  size="sm"
                  className="fw-bold"
                  max={momentDate(new Date(), "YYYY-MM-DD")}
                  value={today}
                  onChange={(e) => setToday(e.target.value)}
                />
                <PieChart
                  series={[
                    {
                      outerRadius: 60,
                      data,
                    },
                  ]}
                  sx={{
                    [`& .${pieArcLabelClasses.root}`]: {
                      fill: "white",
                      fontSize: 14,
                    },
                  }}
                  {...sizing}
                />
              </Col>
              <Col>
                <Row>
                  {dataList.map((item, i) => {
                    return (
                      <Col md={6} className="mb-1 pb-1 border-bottom">
                        <div>{item.payment_method_name}</div>
                        <span className="fw-bold">
                          {commaFormatted(item.total_fee_amount)}
                        </span>
                      </Col>
                    );
                  })}
                </Row>
              </Col>
            </Row>
          </Spin>
        </Card.Body>
      </Card>
    </>
  );
};
export default FeeCollectionChart;
